import { Center, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CircleLoader } from '@/components/ui/core/CircleLoader/CircleLoader';

export const ChatLoader: FC = () => {
  const { t } = useTranslation();

  return (
    <Center>
      <VStack>
        <CircleLoader w={4} h={4} />
        <Text>{t('conversation.loadingChat')}</Text>
      </VStack>
    </Center>
  );
};
